var _require = require('./prettier-comments'),
    handleComments = _require.handleComments;

var massageAstNode = require('./clean');

var loc = require('./loc');

var options = require('./options');

var parse = require('./parser');

var print = require('./printer'); // https://prettier.io/docs/en/plugins.html#languages


var languages = [{
  extensions: ['.sol'],
  name: 'Solidity',
  parsers: ['solidity-parse'],
  vscodeLanguageIds: ['solidity']
}]; // https://prettier.io/docs/en/plugins.html#parsers

var parser = Object.assign({}, {
  astFormat: 'solidity-ast',
  parse: parse
}, loc);
var parsers = {
  'solidity-parse': parser
};

function canAttachComment(node) {
  return node.type && node.type !== 'BlockComment' && node.type !== 'LineComment';
}

function printComment(commentPath) {
  var comment = commentPath.getValue();

  switch (comment.type) {
    case 'BlockComment':
      {
        return "/*".concat(comment.raw, "*/");
      }

    case 'LineComment':
      return "//".concat(comment.raw.trimRight());

    default:
      throw new Error("Not a comment: ".concat(JSON.stringify(comment)));
  }
} // https://prettier.io/docs/en/plugins.html#printers


var printers = {
  'solidity-ast': {
    canAttachComment: canAttachComment,
    handleComments: {
      ownLine: handleComments.handleOwnLineComment,
      endOfLine: handleComments.handleEndOfLineComment,
      remaining: handleComments.handleRemainingComment
    },
    isBlockComment: handleComments.isBlockComment,
    massageAstNode: massageAstNode,
    print: print,
    printComment: printComment
  }
}; // https://prettier.io/docs/en/plugins.html#defaultoptions

var defaultOptions = {
  bracketSpacing: false,
  tabWidth: 4
};
module.exports = {
  languages: languages,
  parsers: parsers,
  printers: printers,
  options: options,
  defaultOptions: defaultOptions
};